module.exports = __webpack_public_path__ + "static/media/icon-mydata-code.581e7462.svg";